module.exports = __webpack_public_path__ + "images/dingtalk/init-document@2x-7e81d96fbc3221495cdcd458f1a9ab8e.png";